import { DealRequestType } from 'app/console-api';
import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import { Icon } from '@iconify/react';
import { useTheme } from 'styled-components';
import {
  getDealsStatusColorMap,
  DealsStatusTitles,
  DealStatus
} from 'app/components/common/deals-statuses/deals-statuses';

interface MyDealsStatusProps {
  status: DealStatus;
  type: DealRequestType;
  statusDescription: string;
  withTable?: boolean;
}

export const MyDealsStatus = ({ status, type, withTable }: MyDealsStatusProps) => {
  const theme = useTheme();

  const aggregatedStatus: DealStatus =
    status === DealStatus.Pending && type === DealRequestType.Incoming
      ? DealStatus.Awaiting
      : status;

  return (
    <FlexColumn>
      <FlexRow gap={5} align={'center'}>
        <Icon
          color={getDealsStatusColorMap(theme)[aggregatedStatus]}
          icon={'ph:circle-fill'}
          scale={1}
        />
        <BodyText
          size={withTable ? 2 : 1}
          scale={'sm'}
          variation={withTable ? 'black' : 'darkGray'}
        >
          {DealsStatusTitles[aggregatedStatus]}
        </BodyText>
      </FlexRow>
    </FlexColumn>
  );
};
